export default "__VITE_ASSET__1d3c150b__"